import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Layout,
  Button,
  Row,
  Col,
  Typography,
  Form,
  Input,
  Switch,
} from "antd";

import signinbg from "../assets/images/img-signin.jpg";
import Swal from "sweetalert2";
import logo from "../assets/images/logo.png";

import { useSelector, useDispatch } from "react-redux";
import { authActions } from "../store";

const SignIn = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authUser = useSelector((x) => x.auth.user);
  // const authError = useSelector((x) => x.auth.error);
  const [checked, setChecked] = useState(true);

  useEffect(() => {
    // redirect to home if already logged in
    if (authUser) {
      navigate("/dashboard");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checked]);

  function onChangeRemember(checked) {
    setChecked(checked);
  }
  const { Title } = Typography;
  const { Footer, Content } = Layout;

  const login = (payload) => {
    const data = {
      username: payload.username,
      password: payload.password,
      // RememberMe: checked,
    };
    dispatch(authActions.login(data))
      .then((res) => {
        if (res.payload === undefined) {
          Swal.fire({
            title: "Error!",
            text: "Đăng Nhập Thất Bại!",
            icon: "error",
            confirmButtonText: "OK",
          });
        } else {
          console.warn("Login Success");
          navigate("/dashboard");
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const onFinish = (values) => {
    login(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <Layout className="layout-default layout-signin">
        <Content className="signin">
          <Row gutter={[24, 0]} justify="space-around">
            <Col
              xs={{ span: 24, offset: 0 }}
              lg={{ span: 6, offset: 2 }}
              md={{ span: 12 }}
            >
              {/* <Title className="mb-15">VN-Farm</Title> */}
              <img src={logo} alt="" />
              <br /> <br /> <br />
              <Title className="font-regular text-muted" level={5}>
                Đăng nhập hệ thống...
              </Title>
   
              <Form
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                layout="vertical"
                className="row-col"
              >
                <Form.Item
                  name="username"
                  className="username"
                  label="Tài khoản"
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng nhập tài khoản!",
                    },
                  ]}
                >
                  <Input placeholder="Username" />
                </Form.Item>

                <Form.Item
                  name="password"
                  className="username"
                  label="Mật khẩu"
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng nhập mật khẩu!",
                    },
                  ]}
                >
                  <Input type="password" placeholder="Password" />
                </Form.Item>

                <Form.Item
                  name="remember"
                  className="aligin-center"
                  valuePropName="checked"
                >
                  <Switch defaultChecked onChange={onChangeRemember} />
                  Ghi nhớ
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: "100%" }}
                  >
                    Đăng Nhập
                  </Button>
                </Form.Item>
              </Form>
            </Col>
            <Col
              className="sign-img"
              style={{ padding: 12 }}
              xs={{ span: 24 }}
              lg={{ span: 12 }}
              md={{ span: 12 }}
            >
              <img src={signinbg} height="90%" alt="" />
            </Col>
          </Row>
        </Content>
        <Footer>
          <p className="copyright">
            {" "}
            Copyright © 2022 Make by <a href="#pablo">VN-FARM</a>.{" "}
          </p>
        </Footer>
      </Layout>
    </>
  );
};
export default SignIn;
